import { Box, CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";

const CustomLoader = ({title, subtitle}) => {
  return (
    <Dialog
      open={true}
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: "24px",
          overflow: "hidden",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,242,246,0.98) 54%, rgba(241,247,255,0.98) 100%)",
          border: "1px solid rgba(123, 80, 111, 0.12)",
          boxShadow: "0 24px 54px rgba(73, 43, 61, 0.14)",
          minWidth: { xs: "280px", sm: "340px" },
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(45, 31, 40, 0.24)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            px: 3,
            py: 3.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: 1.5,
            background:
              "radial-gradient(circle at top, rgba(123, 80, 111, 0.12) 0%, rgba(123, 80, 111, 0.03) 34%, rgba(255,255,255,0) 60%)",
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #7b506f 0%, #a36f91 52%, #d9a47b 100%)",
              boxShadow: "0 14px 28px rgba(123, 80, 111, 0.24)",
            }}
          >
            <CircularProgress
              size={28}
              thickness={4.5}
              sx={{
                color: "#fff",
              }}
            />
          </Box>

          <Typography sx={{ color: "#2d1f28", fontSize: "1rem", fontWeight: 700 }}>
            {title || "Loading content"}
          </Typography>
          <Typography sx={{ color: "#6f6270", fontSize: "0.88rem", fontWeight: 400 }}>
            {subtitle || "Please wait while we prepare your workspace."}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CustomLoader;
